import { render, staticRenderFns } from "./Battlefield2042.vue?vue&type=template&id=2eb70525&lang=pug&"
import script from "./Battlefield2042.vue?vue&type=script&lang=js&"
export * from "./Battlefield2042.vue?vue&type=script&lang=js&"
import style0 from "../assets/themes/bf2042/scss/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports